import { useState } from "react"
import { useSmoothApi } from "src/hooks/useSmoothApi"
import { SMOOTH_LINE_API_URL } from "src/lib/constants"

interface UseDownloadTransferCsvReturn {
  downloadTransferCsv: (id: number) => Promise<void>
}

/**
 * 立替申請送金用CSVダウンロードするためのカスタムフック
 *
 */
export const useDownloadTransferCsv = (): UseDownloadTransferCsvReturn => {
  const { postWithToken } = useSmoothApi()

  /**
   * 立替申請送金用CSVダウンロードする
   * @param id - 申請ID
   */
  const downloadTransferCsv = async (id: number): Promise<void> => {
    try {
      const url = `${SMOOTH_LINE_API_URL}/base_api/smoother/screen/transfer_applications/${id}/download`
      const response = await postWithToken(url, undefined, { responseType: "arraybuffer" })

      // レスポンスタイプによって処理を分岐
      let blob: Blob
      if (response && typeof response === "object" && "data" in response) {
        const responseData = response.data

        // ArrayBuffer（バイナリ）レスポンスの場合
        if (responseData instanceof ArrayBuffer) {
          // Shift_JISエンコードされたバイナリデータをそのままBlobに渡す
          // サーバーから既にShift_JISでエンコードされているため、BOMは不要
          blob = new Blob([responseData], { type: "text/csv" })
        } else if (typeof responseData === "string") {
          // 文字列レスポンス（後方互換性のため）
          blob = new Blob([responseData], { type: "text/csv;charset=shift_jis;" })
        } else {
          throw new Error("CSVデータの形式が不正です")
        }
      } else if (typeof response === "string") {
        blob = new Blob([response], { type: "text/csv;charset=shift_jis;" })
      } else {
        throw new Error("CSVデータの形式が不正です")
      }

      // ダウンロード用のURLを作成
      const downloadUrl = URL.createObjectURL(blob)

      // aタグを作成してダウンロードを実行
      const link = document.createElement("a")
      link.href = downloadUrl
      link.download = `bulk_transfer_${id}.csv`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      // URLを解放してメモリを節約
      URL.revokeObjectURL(downloadUrl)
    } catch (err) {
      const error =
        err instanceof Error ? err : new Error("立替申請送金用CSVダウンロードに失敗しました")
      console.error("立替申請送金用CSVダウンロードに失敗しました:", err)
      throw error
    }
  }

  return {
    downloadTransferCsv,
  }
}
